var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"cols":"12"}},[_c('editor',{attrs:{"toref":_vm.component,"inputref":`${_vm.component}Input`,"toplaceholder":_vm.toplaceholder},model:{value:(_vm.triz.backgroud.allow),callback:function ($$v) {_vm.$set(_vm.triz.backgroud, "allow", $$v)},expression:"triz.backgroud.allow"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }